export default __webpack_public_path__ + "static/media/TR-Testmark_DE.d7271401.png";